// global.js
export default {
    ws: {},
    setWs: function(newWs) {
        this.ws = newWs
        // return this.ws
    }
}




// WEBPACK FOOTER //
// ./src/utils/global.js